import React from "react"
import PropTypes from "prop-types";
import Tr from "translations/Translations";
import {connect} from "react-redux";
import Typography from "components/Typography";

function OfferContractorData(
    {
        offerEdit
    }) {
    return (<>
        <Typography><strong>{Tr("name")}</strong>: {offerEdit.contractor.name}</Typography>
        <Typography><strong>{Tr("contractor_address")}</strong>: {offerEdit.contractor.address ? offerEdit.contractor.address + ',' : ''} {offerEdit.contractor.postCode} {offerEdit.contractor.city}
        </Typography>
        <Typography><strong>{Tr("contractor_nip")}</strong>: {offerEdit.contractor.vatin?.prefix} {offerEdit.contractor.vatin?.number}
        </Typography>
        <Typography><strong>{Tr("email")}</strong>: {offerEdit.contractor.email}</Typography>
    </>)

}

OfferContractorData.propTypes = {
    offerEdit: PropTypes.shape({
        contractor: PropTypes.shape({
            name: PropTypes.string.isRequired,
            address: PropTypes.string.isRequired,
            postCode: PropTypes.string.isRequired,
            city: PropTypes.string.isRequired,
            email: PropTypes.string.isRequired,
            vatin: PropTypes.shape({
                prefix: PropTypes.string.isRequired,
                number: PropTypes.string.isRequired,
            }).isRequired
        }).isRequired
    }),
}
export default connect((state) => ({
    formSubmit: state.form
}), {})(OfferContractorData);